import { render } from "./EmailTemplateManagement.vue?vue&type=template&id=25de7c85&scoped=true&ts=true"
import script from "./EmailTemplateManagement.vue?vue&type=script&lang=ts"
export * from "./EmailTemplateManagement.vue?vue&type=script&lang=ts"

import "./EmailTemplateManagement.vue?vue&type=style&index=0&id=25de7c85&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25de7c85"]])

export default __exports__